/*
 global document, window
*/
export default class Hero {
  constructor() {
    this.attachEventListeners()
  }

  attachEventListeners() {
    if (document.readyState !== 'loading') {
      this.wistiaInit()
    } else {
      document.addEventListener('DOMContentLoaded', this.wistiaInit)
    }
  }

  wistiaInit() {
    if (document.querySelector('.js-hero__video')) {
      const fullScreenVideo = {
        wistiaVideoID: document.querySelector('.js-hero__video > div').id.replace('wistia_', ''),
        embedVideo() {
          /* eslint-disable */
          window._wq = window._wq || []
          window._wq.push({
            id: this.wistiaVideoID,
            options: {
              plugin: { cropFill: { src: '//fast.wistia.com/labs/crop-fill/plugin.js' } }
            }
          })
          /* eslint-enable */
        }
      }
      fullScreenVideo.embedVideo()
    }
  }
}
